export default __webpack_public_path__ + "static/media/tdsa-office-01.48d59b43.jpg";